import styled from 'styled-components';

import loadingIcon from 'assets/images/interface/icon-interface-processing-small.svg';
import StyledIcon from 'shared/Icons/components/StyledIcon';

const Spinner = styled(StyledIcon)`
  pointer-events: none;
  animation: spin-linear 500ms infinite linear;

  @keyframes spin-linear {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoadingSpinner = (
  componentParameters: Omit<Parameters<typeof Spinner>[0], 'props'> & {
    props: Omit<Parameters<typeof Spinner>[0]['props'], 'url'>;
  }
) => <Spinner {...componentParameters} props={{url: loadingIcon, ...componentParameters.props}} />;

export default LoadingSpinner;
